<template>
  <ValidationObserver ref="observer" v-slot="{ invalid, validate }">
    <slot v-bind="{ invalid }" />
    <b-form @submit.prevent="submit(validate, $event)">
      <slot name="submit" :invalid="invalid" />
    </b-form>
  </ValidationObserver>
</template>

<script>
export default {
  name: "w-form",
  props: {
    type: {
      type: String,
      default: "",
    },
  },  
  methods: {
    async submit(validate, e) {
      const valid = await validate();
      // console.log("valid", valid);
      if (valid) {
        this.$emit("submit", e);
      }else{
        if( this.type === 'regist' ){
          window.alert("필수 입력 항목을 작성해주세요.")
        }
      }
    },
  },
};
</script>

<style></style>
